// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../../fragments/commonFragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ConfigureBidGroupsStepQueryVariables = Types.Exact<{
  bidPackageId: Types.Scalars['ID']['input'];
  productOfferingIds: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
}>;


export type ConfigureBidGroupsStepQuery = { __typename?: 'Query', bidPackage: { __typename?: 'BidPackage', id: string, costCodes: Array<{ __typename?: 'CostCode', id: string, name: string }>, costType: { __typename?: 'CostTypeDetail', code: Types.CostType, name: string }, projects: Array<
      | { __typename?: 'StandaloneProject', id: string, name: string }
      | { __typename?: 'Region', id: string, name: string }
      | { __typename?: 'Market', id: string, name: string }
      | { __typename?: 'Community', id: string, name: string }
      | { __typename?: 'Subdivision', id: string, name: string }
      | { __typename?: 'Lot', id: string, name: string }
      | { __typename?: 'Structure', id: string, name: string }
      | { __typename?: 'Unit', id: string, name: string }
    >, productOfferings: Array<{ __typename?: 'ProductOffering', id: string, name: string }>, potentialBidPlanOptions: Array<{ __typename?: 'PotentialBidPlanOption', globalOption: { __typename?: 'GlobalOption', id: string, name: string }, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, readyPlan: { __typename?: 'ReadyPlan', id: string, name: string } }> }>, bidPlanGroups: Array<{ __typename?: 'BidPlanGroup', id: string, order: number, isNoCost: boolean, globalOption?: { __typename?: 'GlobalOption', id: string } | null | undefined, primaryOptionGroup?: { __typename?: 'GlobalOptionGroup', id: string } | null | undefined, dimensions: Array<{ __typename?: 'BidPlanGroupDimension', id: string, globalOptionType?: { __typename?: 'GlobalOptionType', id: string } | null | undefined, globalOptionGroup?: { __typename?: 'GlobalOptionGroup', id: string } | null | undefined, globalOptions: Array<{ __typename?: 'GlobalOption', id: string }> }> }> }, potentialBidPlanDimensions: Array<{ __typename?: 'PotentialBidPlanDimensionResult', id: string, kind: Types.PotentialBidPlanDimensionKind, productOfferings: Array<{ __typename?: 'ProductOffering', id: string, name: string }>, type?: { __typename?: 'GlobalOptionType', order: number, id: string, name: string } | null | undefined, group?: { __typename?: 'GlobalOptionGroup', id: string, name: string, readyPlan?:
        | { __typename?: 'ReadyPlan', id: string, name: string }
        | { __typename?: 'PlanPackage', id: string, name: string }
        | { __typename?: 'DesignPackage', id: string, name: string }
        | { __typename?: 'ProductOffering', id: string, name: string }
       | null | undefined } | null | undefined, options: Array<{ __typename?: 'GlobalOption', id: string, name: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, name: string } | null | undefined }> }> };

export type ConfigureBidGroupsStep_PotentialBidPlanDimensionResultFragment = { __typename?: 'PotentialBidPlanDimensionResult', id: string, kind: Types.PotentialBidPlanDimensionKind, productOfferings: Array<{ __typename?: 'ProductOffering', id: string, name: string }>, type?: { __typename?: 'GlobalOptionType', order: number, id: string, name: string } | null | undefined, group?: { __typename?: 'GlobalOptionGroup', id: string, name: string, readyPlan?:
      | { __typename?: 'ReadyPlan', id: string, name: string }
      | { __typename?: 'PlanPackage', id: string, name: string }
      | { __typename?: 'DesignPackage', id: string, name: string }
      | { __typename?: 'ProductOffering', id: string, name: string }
     | null | undefined } | null | undefined, options: Array<{ __typename?: 'GlobalOption', id: string, name: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, name: string } | null | undefined }> };

export type ConfigureBidGroupsStep_PotentialBidPlanDimension_GlobalOptionFragment = { __typename?: 'GlobalOption', id: string, name: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, name: string } | null | undefined };

export const ConfigureBidGroupsStep_PotentialBidPlanDimension_GlobalOptionFragmentDoc = gql`
    fragment ConfigureBidGroupsStep_PotentialBidPlanDimension_GlobalOption on GlobalOption {
  ...Named
  readyPlan {
    ...Named
  }
}
    ${NamedFragmentDoc}`;
export const ConfigureBidGroupsStep_PotentialBidPlanDimensionResultFragmentDoc = gql`
    fragment ConfigureBidGroupsStep_PotentialBidPlanDimensionResult on PotentialBidPlanDimensionResult {
  id
  kind
  productOfferings {
    ...Named
  }
  type {
    ...Named
    order
  }
  group {
    id
    name
    readyPlan {
      ...Named
    }
  }
  options {
    ...ConfigureBidGroupsStep_PotentialBidPlanDimension_GlobalOption
  }
}
    ${NamedFragmentDoc}
${ConfigureBidGroupsStep_PotentialBidPlanDimension_GlobalOptionFragmentDoc}`;
export const ConfigureBidGroupsStepDocument = gql`
    query ConfigureBidGroupsStep($bidPackageId: ID!, $productOfferingIds: [ID!]!) {
  bidPackage(id: $bidPackageId) {
    id
    costCodes {
      ...Named
    }
    costType {
      code
      name
    }
    projects {
      ...Named
    }
    productOfferings {
      ...Named
    }
    potentialBidPlanOptions {
      globalOption {
        ...Named
      }
      readyPlanOptions {
        id
        readyPlan {
          ...Named
        }
      }
    }
    bidPlanGroups {
      id
      order
      isNoCost
      globalOption {
        id
      }
      primaryOptionGroup {
        id
      }
      dimensions {
        id
        globalOptionType {
          id
        }
        globalOptionGroup {
          id
        }
        globalOptions {
          id
        }
      }
    }
  }
  potentialBidPlanDimensions(productOfferingIds: $productOfferingIds) {
    ...ConfigureBidGroupsStep_PotentialBidPlanDimensionResult
  }
}
    ${NamedFragmentDoc}
${ConfigureBidGroupsStep_PotentialBidPlanDimensionResultFragmentDoc}`;

/**
 * __useConfigureBidGroupsStepQuery__
 *
 * To run a query within a React component, call `useConfigureBidGroupsStepQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfigureBidGroupsStepQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfigureBidGroupsStepQuery({
 *   variables: {
 *      bidPackageId: // value for 'bidPackageId'
 *      productOfferingIds: // value for 'productOfferingIds'
 *   },
 * });
 */
export function useConfigureBidGroupsStepQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ConfigureBidGroupsStepQuery, ConfigureBidGroupsStepQueryVariables> & ({ variables: ConfigureBidGroupsStepQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ConfigureBidGroupsStepQuery, ConfigureBidGroupsStepQueryVariables>(ConfigureBidGroupsStepDocument, options);
      }
export function useConfigureBidGroupsStepLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ConfigureBidGroupsStepQuery, ConfigureBidGroupsStepQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ConfigureBidGroupsStepQuery, ConfigureBidGroupsStepQueryVariables>(ConfigureBidGroupsStepDocument, options);
        }
// @ts-ignore
export function useConfigureBidGroupsStepSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ConfigureBidGroupsStepQuery, ConfigureBidGroupsStepQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ConfigureBidGroupsStepQuery, ConfigureBidGroupsStepQueryVariables>;
export function useConfigureBidGroupsStepSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ConfigureBidGroupsStepQuery, ConfigureBidGroupsStepQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ConfigureBidGroupsStepQuery | undefined, ConfigureBidGroupsStepQueryVariables>;
export function useConfigureBidGroupsStepSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ConfigureBidGroupsStepQuery, ConfigureBidGroupsStepQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ConfigureBidGroupsStepQuery, ConfigureBidGroupsStepQueryVariables>(ConfigureBidGroupsStepDocument, options);
        }
export type ConfigureBidGroupsStepQueryHookResult = ReturnType<typeof useConfigureBidGroupsStepQuery>;
export type ConfigureBidGroupsStepLazyQueryHookResult = ReturnType<typeof useConfigureBidGroupsStepLazyQuery>;
export type ConfigureBidGroupsStepSuspenseQueryHookResult = ReturnType<typeof useConfigureBidGroupsStepSuspenseQuery>;
export type ConfigureBidGroupsStepQueryResult = ApolloReactCommon.QueryResult<ConfigureBidGroupsStepQuery, ConfigureBidGroupsStepQueryVariables>;